'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiCalenderOutline = function TiCalenderOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.7 10.3v-0.3c0-2.8-2.3-5-5-5s-5 2.2-5 5h-3.4c0-2.8-2.2-5-5-5s-5 2.2-5 5v0.3c-1.9 0.7-3.3 2.5-3.3 4.7v15c0 2.8 2.2 5 5 5h20c2.8 0 5-2.2 5-5v-15c0-2.2-1.4-4-3.3-4.7z m-6.7-0.3c0-0.9 0.7-1.7 1.7-1.7s1.6 0.8 1.6 1.7v3.3c0 1-0.7 1.7-1.6 1.7s-1.7-0.7-1.7-1.7v-3.3z m-13.3 0c0-0.9 0.7-1.7 1.6-1.7s1.7 0.8 1.7 1.7v3.3c0 1-0.7 1.7-1.7 1.7s-1.6-0.7-1.6-1.7v-3.3z m20 20c0 0.9-0.8 1.7-1.7 1.7h-20c-0.9 0-1.7-0.8-1.7-1.7v-10h23.4v10z m0-11.7h-23.4v-3.3c0-0.9 0.8-1.7 1.7-1.7 0 1.9 1.5 3.4 3.3 3.4s3.4-1.5 3.4-3.4h6.6c0 1.9 1.5 3.4 3.4 3.4s3.3-1.5 3.3-3.4c0.9 0 1.7 0.8 1.7 1.7v3.3z' })
        )
    );
};

exports.default = TiCalenderOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/calender-outline.js
// module id = 1997
// module chunks = 0